<template>
  <v-layout row wrap align-center justify-end>
    <v-flex xs12 sm4 lg2 pa-2>
      <v-select
        v-model="calMonth"
        :items="monthOptions"
        label="Month"
        @change="$emit('change')"
      ></v-select>
    </v-flex>
    <v-flex xs12 sm4 lg2 pa-2>
      <v-select
        v-model="calYear"
        :items="yearOptions"
        label="Year"
        @change="$emit('change')"
      ></v-select>
    </v-flex>
    <v-flex xs12 sm4 lg2 pa-2>
      <TimePicker
        v-model="timeRange"
        @change="$emit('change')"  
      />
    </v-flex>
    <v-flex xs12 sm4 lg2 pa-2 v-if="view=='park'">
      <FieldAutocomplete
        v-model="fieldCode"
        label="Field"
        :parkCode="parkCode"
        @change="$emit('change')"
        ref="fieldAutocomplete"
      />
    </v-flex>
    <v-flex xs12 pa-2 :class="{sm4:view=='park',lg2:view=='park',sm6:view=='field',lg3:view=='field'}">
      <v-combobox
        v-model="purpose"
        label="Purpose"
        :items="['Game', 'Practice']"
        clearable
        @change="$emit('change')"
        @click:clear="delayedChange"
      />
    </v-flex>
    <v-flex xs12 pa-2 :class="{sm4:view=='park',lg2:view=='park',sm6:view=='field',lg3:view=='field'}">
      <v-text-field
        v-model="reservee"
        label="Reservee"
        clearable
        @change="$emit('change')"
        @click:clear="delayedChange"
      />
    </v-flex>
  </v-layout>
</template>

<script>
  import moment from 'moment'
  import FieldAutocomplete from '@/components/FieldAutocomplete'
  import TimePicker from '@/components/TimePicker'

  export default {
    components: {
      FieldAutocomplete,
      TimePicker
    },
    computed: {
      monthOptions () {
        return Array.apply(null, Array(12)).map((item, index) => {
          let projected = moment().month(index).year(this.calYear).startOf('month')
          return {
            text: projected.format('MMMM'),
            disabled: moment(this.$store.state.config.maxDate).isBefore(projected)
              || moment(this.$store.state.config.minDate).isAfter(projected)
          }
        })
      },
      yearOptions () {
        let years = []
        let minYear = parseInt(moment(this.$store.state.config.minDate).format('YYYY'))
        let maxYear = parseInt(moment(this.$store.state.config.maxDate).format('YYYY'))
        for(let year = minYear; year <= maxYear; year++)
          years.push(year)
        return years
      },
      view: {
        get () { return this.$store.state.details.view },
        set (value) { this.$store.commit('setDetails', { filter: 'view', value }) }
      },
      parkCode: {
        get () { return this.$store.state.details.parkCode },
        set (value) { this.$store.commit('setDetails', { filter: 'parkCode', value }) }
      },
      fieldCode: {
        get () { return this.$store.state.details.fieldCode },
        set (value) { this.$store.commit('setDetails', { filter: 'fieldCode', value }) }
      },
      purpose: {
        get () { return this.$store.state.details.purpose },
        set (value) { this.$store.commit('setDetails', { filter: 'purpose', value }) }
      },
      reservee: {
        get () { return this.$store.state.details.reservee },
        set (value) { this.$store.commit('setDetails', { filter: 'reservee', value }) }
      },
      timeRange: {
        get () { return this.$store.state.details.timeRange },
        set (value) { this.$store.commit('setDetails', { filter: 'timeRange', value }) }
      },
      calMonth: {
        get () { return moment().month(this.$store.state.details.month-1).format('MMMM') },
        set (value) { this.$store.commit('setDetails', { filter: 'month', value: moment().month(value).format('M') }) }
      },
      calYear: {
        get () { return parseInt(this.$store.state.details.year) },
        set (value) { this.$store.commit('setDetails', { filter: 'year', value }) }
      }
    },
    methods: {
      delayedChange () {
        this.$nextTick(function() {
          this.$emit('change')
        })
      },
      init () {
        if(this.view=='park')
          this.$refs.fieldAutocomplete.init()
      }
    }
  }
</script>